<template>
<div class="menuBody" >
    <RoomManTree @RoomManTree="getMsgFormSon" />
        <RoomDialog :param="diaLogData" ref="RoomDialog" @Visible="GetVisible"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="border-bottom:1px solid rgba(234, 237, 241, 1);width:100%;height:30px;margin-bottom:10px">
                房间管理
            </div>
            <div style="width:150px;float:left;">
                 <el-input placeholder="请输入房间全称" size="small"     v-model="roomName"></el-input>
            </div>
            <div style="width:170px;float:left;margin-left:70px">
                <el-select  clearable v-model="Roomvalue" placeholder="请选择房间状态"  size="small" >
                    <el-option v-for="item in RoomStatus" :key="item.Roomvalue" :label="item.Roomlabel" :value="item.Roomvalue"></el-option>
                </el-select>
            </div>
             <div style="width:170px;float:left;margin-left:60px">
                <el-select  clearable v-model="Fitmentvalue" placeholder="请选择装修情况"  size="small" >
                    <el-option v-for="item in FitmentStatus" :key="item.Fitmentvalue" :label="item.Fitmentlabel" :value="item.Fitmentvalue"></el-option>
                </el-select>
            </div>
            <div style="float:left;margin-left:70px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'wy:web:pm:room:list'" @click="Inquire()" >查询</el-button>
            </div>
            <div style="float:right">
                <el-button type="primary" size="small" plain style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'wy:web:pm:room:add'" @click="PropertyAdd()">添加房间</el-button>
            </div>


         <el-table tooltip-effect="light"  @selection-change="handleSelectionChange" v-loading="loading" :data="tableData"    style="margin-top:30px; overflow-y: scroll;float:right" row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
        <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column show-overflow-tooltip prop="floorName" label="楼宇全称"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="roomName" label="室号全称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="unitNo" label="单元号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="roomCode" label="房间号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="buildArea" label="建筑面积" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="roomStatus" label="房间状态" >
      <template slot-scope="scope">
        <el-tag  v-if="scope.row.roomStatus=='1'" >空置</el-tag>
        <el-tag v-if="scope.row.roomStatus=='2'" >已租</el-tag>
        <el-tag  v-if="scope.row.roomStatus=='3'" >入住</el-tag>
        <el-tag  v-if="scope.row.roomStatus=='4'" >迁出</el-tag>
        <el-tag  v-if="scope.row.roomStatus== null" >其他</el-tag>
      </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="roomProperty" label="房间属性" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="decorate" label="装修状态" >
      <template slot-scope="scope">
        <el-tag  v-if="scope.row.decorate=='0'" >否</el-tag>
        <el-tag v-if="scope.row.decorate=='1'" >是</el-tag>
      </template>
    </el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注信息" ></el-table-column>
    <el-table-column fixed="right" label="操作"  width="120px"  >
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" v-Jurisdiction="'wy:web:pm:room:edit'" title="修改"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除" v-Jurisdiction="'wy:web:pm:room:del'"  v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table> 
        <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>  
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import RoomDialog from "../common/RoomDialog";
import RoomManTree from "../common/RoomManTree.vue";

export default {
  name: "RoomManagement",
  components: {RoomDialog,RoomManTree},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        roomName:"",
      tableData: [],

      // 1:空置；2:已租；3:入住；4:迁出
      
  RoomStatus: [{
          Roomvalue: '1',
          Roomlabel: '空置'
        }, {
          Roomvalue: '2',
          Roomlabel: '已租'
        }, {
          Roomvalue: '3',
          Roomlabel: '入住'
        }, {
          Roomvalue: '4',
          Roomlabel: '迁出'
        }],
        Roomvalue: '',
       FitmentStatus: [{
          Fitmentvalue: '0',
          Fitmentlabel: '否'
        }, {
          Fitmentvalue: '1',
          Fitmentlabel: '是'
        }],
        Fitmentvalue: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERList:"",
      projectId:"",
      floorId:"",
    }
  },
  methods: {
      handleSelectionChange(val){
          // console.log(val)
      },

      Inquire(){
        let obj = {
          "roomName":this.roomName,
          "roomStatus":this.Roomvalue,
          "decorate":this.Fitmentvalue,
          "page":this.currentPage, // 当前页
          "size":this.pagesize,  // 每页大小
          "floorId":this.AllData.id,
        }
        this.$http.post(this.$requestUrl.POST_ROOM_LIST,obj).then((res) => {
          let data = res.data;
          if (200 === data.code) {
              for(let val of data.data.records){
                val.orgCode = val.floorName+val.roomName
              }
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
          this.loading = false
        })

      },
    getMsgFormSon(data){
      this.AllData = data
      this.projectId = data.projectIdT
      this.floorId = data.id
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "projectId":data.projectIdT,
        "floorId":data.id,
      }
        this.$http.post(this.$requestUrl.POST_ROOM_LIST,PageSize).then((res) => {
          let data = res.data;
           
          if (200 === data.code) {
              this.total = data.data.total
              for(let val of data.data.records){
                val.orgCode = val.floorName+val.roomName
              }
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
          this.loading = false
        })
    },
    handleSizeChange(val) {
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "projectId":this.projectId,
        "floorId":this.floorId,
      }
        this.$http.post(this.$requestUrl.POST_ROOM_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
              for(let val of data.data.records){
                val.orgCode = val.floorName+val.roomName
              }
            this.loading = false
            this.total = data.data.total
            this.tableData = data.data.records;
          } else {
            this.loading = false
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.loading = false
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
      },
    PropertyAdd(){
        // 添加项目
      this.$refs.RoomDialog.title = "添加";
      this.$refs.RoomDialog.dialogVisible = true; 
      this.$refs.RoomDialog.formLabelAlign = {};
      this.$refs.RoomDialog.floorId= this.floorId
      this.$refs.RoomDialog.projectId = this.projectId
    },
    editMenu(row) { // 修改
      this.$http.get(this.$requestUrl.GEI_WY_ROOM+row.roomId).then((res) => {
        let result = res.data;
          if (200 === result.code) {
            console.log(res.data.data)
                  this.$refs.RoomDialog.title = "修改";
      this.$refs.RoomDialog.roomProperty = row.roomProperty
      this.$refs.RoomDialog.value = row.roomStatus
      this.$refs.RoomDialog.dialogVisible = true; 
      this.$refs.RoomDialog.formLabelAlign= res.data.data;
      this.$refs.RoomDialog.floorId= this.floorId
      this.$refs.RoomDialog.roomId =row.roomId
      this.$refs.RoomDialog.projectId = this.projectId
          }else{
          
          }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    delMenu(row){
           this.$confirm('是否确认要删除该房间?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
               this.$http.delete(this.$requestUrl.DELETE_ROOM+row.roomId).then((res) => {
        let result = res.data;
          if (200 === result.code) {
              this.$message({
            type: 'success',
            message: '删除成功!'
          });
            this.getAllMenu()
          }else{
             this.$message({
            type: 'warning',
            message: '删除失败'
          });
          }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
        },
    GetVisible(data){
      if(data == false){
        this.loading = true
        this.getAllMenu()
      }
    }
  },
  mounted() {
          // this.getUserOffice();
          this.getAllMenu()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>